<template>
  <div id="input-image-area">
    <label class="image-upload--label">{{ label }}</label>
    <vs-row class="mt-2">
      <vs-col>
        <div
          v-show="!imgSrc && !pdfSrc"
          :class="[isDrag ? dragoverClass : dragleaveClass]"
          @dragover.prevent="handleDragOver($event, false)"
          @dragleave.prevent="handleDragLeave($event, false)"
          @drop.prevent="handleFileSelect($event, false)"
          @click="$refs.upload_image_input.click()"
        >
          <input
            type="file"
            ref="upload_image_input"
            class="hidden"
            @change="handleFileSelect($event)"
          />
          <span class="text-drag-area"
            >画像ファイルをドロップ、<br />またはクリックしてファイルを選択<br /><br />
            <small
              >フォーマット: JPEG、JPG、PNG, PDF<br />最大アップロードサイズ:
              5MB</small
            ></span
          >
        </div>
        <div v-show="imgSrc" class="full-area">
          <img :src="imgSrc" class="image-area" />
        </div>
        <div v-show="pdfSrc" class="full-area">
          <pdf :src="pdfSrc" class="pdf-area pt-4 pb-4" />
        </div>
      </vs-col>
    </vs-row>
    <vs-row
      v-show="imgSrc || pdfSrc"
      vs-type="flex"
      vs-justify="space-around"
      class="mt-4"
    >
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="15">
        <vs-button
          v-show="!editMode"
          size="small"
          type="border"
          color="dark"
          @click="cleanUp"
          >削除</vs-button
        >
        <vs-button
          v-show="editMode"
          size="small"
          type="border"
          color="danger"
          @click="cleanUp"
          >画像を削除する</vs-button
        >
      </vs-col>
    </vs-row>
    <span class="text-danger text-sm" v-show="error.message">{{
      error.message
    }}</span>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: { pdf },
  name: "vx-card",
  props: {
    label: {
      type: String,
      default: ""
    },
    styleObject: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      editMode: false,
      error: { message: null },
      showDialog: false,
      title: "プロフィール画像の変更",
      acceptText: "保存",
      cancelText: "キャンセル",
      isValid: false,
      showProgress: false,
      pictureData: {},
      pictureUrl: null,
      imgSrc: null,
      pdfSrc: null,
      fileSIze: null,
      fileName: null,
      cropImg: null,
      isDrag: false,
      isCrop: null,
      dragleaveClass: "drag-area-dragleave",
      dragoverClass: "drag-area-dragover",
      showButton: false
    };
  },
  methods: {
    setEditMode(isEdit) {
      this.editMode = isEdit;
    },
    setImgSrc(src) {
      this.imgSrc = src;
    },
    deleteImgSrc() {
      this.imgSrc = null;
      this.isDrag = false;
    },
    deletePdfSrc() {
      this.pdfSrc = null;
      this.isDrag = false;
    },
    handleFileSelect(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      let file =
        typeof evt.target.files !== "undefined"
          ? evt.target.files[0]
          : evt.dataTransfer.files[0];
      if (!this.validate(file)) {
        return;
      }
      evt.target.value = null;
      let reader = new FileReader();
      reader.onload = e => {
        if (file.type === "application/pdf") {
          this.pdfSrc = e.target.result;
          this.$emit("onSetImage", { src: this.pdfSrc, type: file.type });
        } else {
          this.imgSrc = e.target.result;
          this.$emit("onSetImage", { src: this.imgSrc, type: file.type });
        }
      };
      reader.readAsDataURL(file);
    },
    handleDragOver(evt) {
      this.isDrag = true;
      evt.stopPropagation();
      evt.preventDefault();
      evt.dataTransfer.dropEffect = "copy";
    },
    handleDragLeave(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      evt.dataTransfer.dropEffect = "copy";
    },
    validate(file) {
      if (!file.type.match("image.*") && file.type != "application/pdf") {
        this.error.message =
          "指定されたフォーマット以外はアップロードできません";
        return false;
      }

      this.fileSIze = file.size;
      if (this.fileSIze >= 5000000) {
        this.error.message = "サイズは5メガバイト以下にしてください";
        return false;
      }

      this.error.message = null;

      return true;
    },
    cleanUp() {
      if (!this.editMode) {
        this.deleteImgSrc();
        this.deletePdfSrc();
        this.$emit("onClearImage");
      } else {
        this.$emit("onDeleteImage");
      }
    }
  }
};
</script>

<style lang="scss">
#input-image-area {
  .drag-area-dragleave {
    width: 100%;
    min-width: 200px;
    height: 100%;
    min-height: 200px;
    border: 2px dashed rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
  }

  .drag-area-dragover {
    width: 100%;
    min-width: 200px;
    height: 100%;
    min-height: 200px;
    border: 2px dashed rgba(115, 103, 240, 1);
    border-radius: 8px;
    padding: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
  }
  .image-area {
    width: 100%;
    min-width: 200px;
    height: 200px;
    min-height: 200px;
    border-radius: 8px;
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4));
    object-fit: scale-down;
  }

  .pdf-area {
    width: 100%;
    min-height: 200px;
    border-radius: 8px;
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4));
    object-fit: scale-down;
  }
  .text-drag-area {
    font-size: smaller;
    color: #bbb;
  }

  .full-area {
    position: relative;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .image-upload--label {
    margin-top: 0px;
    margin-left: 5px;
    padding-left: 0px;
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.7);
  }

  .con-upload-license-add {
    .con-img-upload {
      padding: 0;
    }
    .con-input-upload {
      margin-top: 0px;
      margin-left: 12px;
    }
  }
}
</style>
